import { useMemo } from 'react';

import { Box, Typography } from '@mui/material';

import { PROCESS_STATUS } from 'appConstants';
import { ProcessStatus } from 'appTypes';
import { StlButton } from 'features/common/StlButton/StlButton';

import { classNames } from '../utils';

import styles from './StlRecentList.module.css';

export default function StlRecentList<T>({
  viewMode = false,
  currentId,
  status,
  items,
  idAccessor,
  onViewAll,
  listComponent,
  classes = [],
}: {
  viewMode?: boolean;
  currentId?: string;
  status: ProcessStatus;
  items: T[];
  idAccessor: keyof T;
  onViewAll: () => void;
  listComponent: React.ComponentType<any>;
  classes?: string[];
}) {
  const isDone = status === PROCESS_STATUS.DONE;

  const hasCurrentScenario = useMemo(() => {
    if (!currentId) return false;
    return items.some((s) => s[idAccessor] === currentId);
  }, [currentId, items, idAccessor]);

  const highlightSelected = viewMode;
  const selectedHighlighted = highlightSelected && hasCurrentScenario;
  const showRecent = !selectedHighlighted || items.length > 1;

  const shortList = showRecent && viewMode && isDone;

  const wrapperClass = classNames(
    styles.recent_item_wrapper,
    shortList && styles.recent_item_wrapper_short,
    ...classes,
  );

  const ListToRender = listComponent;

  return (
    <Box
      className={wrapperClass}
      sx={
        selectedHighlighted && !showRecent ? { minHeight: '200px' } : undefined
      }
    >
      {selectedHighlighted && (
        <ListToRender selectedOnly highlightSelected={highlightSelected} />
      )}
      {showRecent && (
        <>
          <Box className={styles.recent_item_list_header}>
            <Typography variant="h3" fontWeight={500}>
              Recent
            </Typography>
            <StlButton
              value="View All"
              handleClick={onViewAll}
              width={64}
              variant="text"
            />
          </Box>
          <ListToRender
            excludeSelected={selectedHighlighted}
            highlightSelected={false}
            limit={3}
          />
        </>
      )}
    </Box>
  );
}
